'use client';

import { c as _c } from "react/compiler-runtime";
import { VaultConfigurationSectionLoading } from '../../VaultConfiguration/states';
import { ApyCardLoading } from '../ApyCard/states';
import { ChartTotalDepositLoading } from '../ChartTotalDeposit/states';

/** Mirrors `VaultOverview.server.tsx` for the vault route `loading.tsx`. */
const VaultOverviewLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="gap-lg sm:gap-xl flex flex-col"><VaultConfigurationSectionLoading /><ChartTotalDepositLoading /><ApyCardLoading /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default VaultOverviewLoading;